(() => {
  function init(root) {
    if (root.dataset.t2Ready) return;
    root.dataset.t2Ready = 'true';
    const data = JSON.parse(root.querySelector('[data-t2-data]').textContent);
    const slides = root.querySelector('[data-t2-slides]');
    const frames = [...slides.querySelectorAll('[data-t2-photo]')];
    const dots = [...root.querySelectorAll('[data-t2-dot], [data-t2-thumb]')];
    const thumbs = [...root.querySelectorAll('[data-t2-thumb]')];
    const form = root.querySelector('[data-t2-form]');
    const buy = root.querySelector('[data-t2-buy]');
    const stickyBuy = root.querySelector('[data-t2-sticky-buy]');
    const error = root.querySelector('[data-t2-error]');
    const viewer = root.querySelector('[data-t2-viewer]');
    const viewerImage = root.querySelector('[data-t2-viewer-image]');
    let color = 'black', current = 0, viewerIndex = 0, busy = false, scrollFrame;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const photo = i => data.colors[color].photos[(i + frames.length) % frames.length];
    function preload(i) { const img = new Image(); img.src = photo(i).src; }
    function indicator(i) {
      current = ((Number.isFinite(i) ? i : 0) + frames.length) % frames.length;
      dots.forEach(dot => dot.setAttribute('aria-current', String(Number(dot.dataset.t2Dot ?? dot.dataset.t2Thumb) === current)));
      root.querySelector('[data-t2-count]').textContent = `${current + 1} / ${frames.length}`;
      preload(current + 1);
    }
    function go(i) {
      const target = (i + frames.length) % frames.length;
      slides.scrollTo({left: target * slides.clientWidth, behavior: reduced ? 'auto' : 'smooth'});
      indicator(target);
    }
    function selectColor(next, updateUrl = true) {
      color = next;
      const variant = data.colors[color];
      root.querySelectorAll('[data-t2-color]').forEach(button => { const active = button.dataset.t2Color === color; button.setAttribute('aria-pressed', String(active)); button.classList.toggle('is-active', active); });
      root.querySelector('[data-t2-color-name]').textContent = variant.label;
      root.querySelector('[data-t2-sticky-color]').textContent = variant.label;
      root.querySelector('[data-t2-price]').textContent = variant.price;
      root.querySelector('[data-t2-sticky-price]').textContent = variant.price;
      form.querySelector('[name="id"]').value = variant.id;
      form.dataset.selectedVariant = variant.id;
      buy.disabled = stickyBuy.disabled = !variant.available || busy;
      buy.textContent = busy ? 'Adding…' : !data.published ? 'Coming soon' : variant.available ? 'Add to cart' : 'Sold out';
      stickyBuy.textContent = busy ? 'Adding…' : !data.published ? 'Coming soon' : variant.available ? 'Add to cart' : 'Sold out';
      frames.forEach((frame, i) => {
        const img = frame.querySelector('img'), item = variant.photos[i];
        img.src = item.src; img.alt = item.alt;
        frame.setAttribute('aria-label', `Enlarge photo ${i + 1}: ${item.alt}`);
        const thumb = thumbs[i]?.querySelector('img');
        if (thumb) { thumb.src = item.src; thumb.alt = item.alt; }
      });
      slides.scrollTo({left:0,behavior:'instant'}); indicator(0); error.hidden = true;
      if (updateUrl) {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }
    }
    function showViewer(i) {
      viewerIndex = (i + frames.length) % frames.length;
      viewer.querySelectorAll('[data-t2-viewer-prev], [data-t2-viewer-next], [data-t2-viewer-count]').forEach(control => { control.hidden = false; });
      const item = photo(viewerIndex);
      viewerImage.src = item.src; viewerImage.alt = item.alt;
      root.querySelector('[data-t2-viewer-count]').textContent = `${viewerIndex + 1} / ${frames.length}`;
      preload(viewerIndex + 1); preload(viewerIndex - 1);
      if (!viewer.open) viewer.showModal();
    }
    root.querySelector('[data-t2-included]')?.addEventListener('click', event => {
      const item = event.currentTarget.querySelector('img');
      viewerIndex = null;
      viewerImage.src = item.currentSrc || item.src;
      viewerImage.alt = item.alt;
      viewer.querySelectorAll('[data-t2-viewer-prev], [data-t2-viewer-next], [data-t2-viewer-count]').forEach(control => { control.hidden = true; });
      if (!viewer.open) viewer.showModal();
    });
    root.querySelectorAll('[data-t2-color]').forEach(button => button.addEventListener('click', () => selectColor(button.dataset.t2Color)));
    root.querySelector('[data-t2-prev]').addEventListener('click', () => go(current - 1));
    root.querySelector('[data-t2-next]').addEventListener('click', () => go(current + 1));
    dots.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.t2Dot ?? button.dataset.t2Thumb))));
    slides.addEventListener('scroll', () => { cancelAnimationFrame(scrollFrame); scrollFrame = requestAnimationFrame(() => slides.clientWidth > 0 && indicator(Math.round(slides.scrollLeft / slides.clientWidth))); }, {passive:true});
    slides.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); } });
    frames.forEach((frame, i) => frame.addEventListener('click', () => showViewer(i)));
    root.querySelector('[data-t2-viewer-prev]').addEventListener('click', () => showViewer(viewerIndex - 1));
    root.querySelector('[data-t2-viewer-next]').addEventListener('click', () => showViewer(viewerIndex + 1));
    root.querySelector('[data-t2-close]').addEventListener('click', () => viewer.close());
    viewerImage.addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', event => { if (event.target === viewer) viewer.close(); });
    viewer.addEventListener('keydown', event => { if (viewerIndex !== null && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) { event.preventDefault(); showViewer(viewerIndex + (event.key === 'ArrowRight' ? 1 : -1)); } });
    let startX = null;
    viewerImage.addEventListener('touchstart', event => { startX = event.touches[0].clientX; }, {passive:true});
    viewerImage.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - startX; if (viewerIndex !== null && Math.abs(delta) > 50) { event.preventDefault(); showViewer(viewerIndex + (delta < 0 ? 1 : -1)); } startX = null; });
    root.querySelectorAll('[data-t2-quantity]').forEach(button => button.addEventListener('click', () => {
      const input = form.elements.quantity;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.t2Quantity));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    const sticky = root.querySelector('[data-t2-sticky]');
    const mobile = matchMedia('(max-width:749px)');
    let mainVisible = true, previewMenuOpen = false, previewWrapper = null;
    const syncSticky = () => {
      const rect = buy.getBoundingClientRect();
      mainVisible = rect.bottom > 0 && rect.top < innerHeight;
      sticky.classList.toggle('is-visible', !previewMenuOpen && (mobile.matches || !mainVisible));
    };
    window.addEventListener('scroll', syncSticky, {passive:true});
    const observer = new IntersectionObserver(entries => { mainVisible = entries[0].isIntersecting; syncSticky(); });
    observer.observe(buy); mobile.addEventListener('change', syncSticky);
    const syncPreview = () => {
      const rect = previewWrapper?.getBoundingClientRect();
      previewMenuOpen = Boolean(rect && rect.height > innerHeight * .4);
      const offset = rect && !previewMenuOpen && rect.bottom > 0 ? Math.max(0, innerHeight - rect.top) : 0;
      document.documentElement.style.setProperty('--ember-preview-offset', `${offset}px`);
      syncSticky();
    };
    const previewObserver = new ResizeObserver(syncPreview);
    const attachPreview = () => {
      const wrapper = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      if (wrapper && wrapper !== previewWrapper) { if (previewWrapper) previewObserver.unobserve(previewWrapper); previewWrapper = wrapper; previewObserver.observe(wrapper); }
      syncPreview();
    };
    new MutationObserver(attachPreview).observe(document.body, {childList:true});
    attachPreview(); window.addEventListener('resize', syncPreview);
    stickyBuy.addEventListener('click', () => form.requestSubmit());
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !data.colors[color].available || !data.published) return;
      busy = true; buy.disabled = stickyBuy.disabled = true;
      buy.textContent = stickyBuy.textContent = 'Adding…'; error.hidden = true;
      try {
        const payload = new FormData(form);
        // The preview uses the original Tumbler route; app scripts may rewrite its hidden variant input.
        payload.set('id', String(data.colors[color].id));
        payload.set('quantity', String(Math.max(1, parseInt(form.elements.quantity.value, 10) || 1)));
        const response = await fetch(form.action + '.js', {method:'POST',headers:{'Accept':'application/json'},body:payload});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'We could not add this item. Please try again.');
        location.assign(data.cartUrl);
      } catch (e) {
        busy = false; selectColor(color, false);
        error.textContent = e.message; error.hidden = false;
      }
    });
    const variant = new URL(location.href).searchParams.get('variant');
    selectColor(variant === String(data.colors.sandstone.id) ? 'sandstone' : 'black', false);
    window.addEventListener('resize', () => slides.scrollTo({left: current * slides.clientWidth, behavior:'instant'}));
  }
  document.querySelectorAll('[data-t2-pdp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-t2-pdp]').forEach(init));
})();
